/**
 * Единый список разделов ученика: шапка и плашки на главной.
 * Условия показа зависят от user / activeLesson / topicPrograms.
 */

export function activeLessonHref(activeLesson) {
  if (!activeLesson) return '/tasks';
  if (activeLesson.work_list_first_task_slug && activeLesson.work_list_id) {
    return `/work/${activeLesson.work_list_first_task_slug}?list=${activeLesson.work_list_id}`;
  }
  return '/tasks';
}

/** Основные пункты (меню + группа «Основные» на главной). */
export function getStudentPrimaryItems({ user, activeLesson } = {}) {
  const items = [];

  if (user?.telemost_url) {
    items.push({
      id: 'telemost',
      label: 'Телемост',
      icon: 'fa-video',
      external: user.telemost_url,
      title: 'Войти в конференцию',
      inNav: true,
      onHome: true,
    });
  }

  if (activeLesson) {
    items.push({
      id: 'lesson',
      label: 'Урок',
      icon: 'fa-chalkboard-user',
      to: activeLessonHref(activeLesson),
      live: true,
      inNav: true,
      onHome: true,
    });
  }

  items.push(
    {
      id: 'schedule',
      label: 'Расписание',
      icon: 'fa-calendar-days',
      to: '/my-schedule',
      inNav: true,
      onHome: true,
    },
    {
      id: 'homework',
      label: 'ДЗ',
      icon: 'fa-list-check',
      to: '/tasks',
      inNav: true,
      onHome: true,
    },
    {
      id: 'quizzes',
      label: 'Тесты',
      icon: 'fa-clipboard-check',
      to: '/practice-quizzes',
      inNav: true,
      onHome: true,
    },
    {
      id: 'trainers',
      label: 'Тренажёры',
      icon: 'fa-bullseye',
      to: '/trainers',
      inNav: true,
      onHome: true,
    },
    {
      id: 'konspekt',
      label: 'Конспект',
      icon: 'fa-book',
      to: '/konspekty',
      inNav: true,
      onHome: true,
    },
    {
      id: 'messages',
      label: 'Сообщения',
      icon: 'fa-envelope',
      to: '/my-messages',
      inNav: true,
      onHome: true,
    },
    {
      id: 'lessons',
      label: 'Журнал занятий',
      icon: 'fa-clipboard-list',
      to: '/my-lessons',
      inNav: true,
      onHome: true,
    },
    {
      id: 'billing',
      label: 'Баланс',
      icon: 'fa-wallet',
      to: '/billing',
      inNav: true,
      onHome: true,
    },
  );

  return items;
}

/** Дополнительные плашки только на главной. */
export function getStudentMoreItems({ user, topicPrograms = [] } = {}) {
  const collabTo = user?.collab_session_id
    ? `/collaborative/${user.collab_session_id}`
    : '/collaborative';

  const items = [
    {
      id: 'teachers',
      label: 'Мои преподаватели',
      icon: 'fa-chalkboard',
      to: '/my-teachers',
      onHome: true,
    },
    {
      id: 'topic-progress',
      label: 'Прогресс по темам',
      icon: 'fa-chart-line',
      to: '/topic-progress',
      onHome: true,
    },
    {
      id: 'attempts',
      label: 'Мои попытки',
      icon: 'fa-clock-rotate-left',
      to: '/my-attempts',
      onHome: true,
    },
    {
      id: 'collab',
      label: 'Совместное кодирование',
      icon: 'fa-users',
      to: collabTo,
      onHome: true,
    },
    {
      id: 'catalog',
      label: 'Каталог задач',
      icon: 'fa-book-open',
      to: '/catalog',
      onHome: true,
    },
  ];

  for (const p of topicPrograms) {
    items.push({
      id: `theme-${p.slug}`,
      label: p.label || p.slug,
      icon: 'fa-graduation-cap',
      to: `/themes/${p.slug}`,
      onHome: true,
    });
  }

  return items;
}

export function getStudentNavItems(ctx) {
  return getStudentPrimaryItems(ctx).filter((item) => item.inNav);
}

export function getStudentHomePrimaryItems(ctx) {
  return getStudentPrimaryItems(ctx).filter((item) => item.onHome);
}
